<template>
  <div class="contact-page">
    <CommonHeader />
    <div class="contact-banner">
      <div class="banner-content">
        <h1 class="animate-fade-in">{{ $t('contact.title') }}</h1>
      </div>
    </div>
    <div class="contact-content-wrapper">
      <div class="contact-card">
        <div class="contact-item">
          <div class="item-header">
            <div class="icon-circle">
              <img src="@/assets/phone/1.png" alt="phone" />
            </div>
            <div class="item-label">{{ $t('contact.hotline') }}</div>
          </div>
          <div class="item-value strong">0571-87352558</div>
        </div>
        <div class="contact-item">
          <div class="item-header">
            <div class="icon-circle">
              <img src="@/assets/phone/2.png" alt="fax" />
            </div>
            <div class="item-label">{{ $t('contact.fax') }}</div>
          </div>
          <div class="item-value strong">0571-87352559</div>
        </div>
        <div class="contact-item">
          <div class="item-header">
            <div class="icon-circle">
              <img src="@/assets/phone/3.png" alt="mail" />
            </div>
            <div class="item-label">{{ $t('contact.email') }}</div>
          </div>
          <div class="item-value strong">office@cosys.com.cn</div>
        </div>
        <div class="contact-item address-item">
          <div class="item-header">
            <div class="icon-circle">
              <img src="@/assets/phone/4.png" alt="address" />
            </div>
            <div class="item-label">{{ $t('contact.address') }}</div>
          </div>
          <div class="item-value address-text">
            {{ $t('contact.addressContent.hq') }}<br />
          </div>
        </div>
      </div>
    </div>
    <CommonSection type="footer" id="footer" />
  </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader.vue';
import CommonSection from '@/components/CommonSection.vue';

export default {
  name: 'ContactView',
  components: {
    CommonHeader,
    CommonSection
  }
}
</script>

<style lang="scss" scoped>
.contact-page {
  min-height: 100vh;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
}

.contact-banner {
  width: 100%;
  height: 65vh;
  background: url('~@/assets/phone/banner.jpg') no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 0;

  .banner-content {
    text-align: center;
    color: #fff;

    h1 {
      font-size: 48px;
      font-weight: 600;
      margin-bottom: 15px;
      letter-spacing: 2px;
      padding: 18px 48px;
      border-radius: 8px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,0.06);
    }
  }
}

.contact-content-wrapper {
  width: 100%;
  max-width: 1400px;
  margin: 60px auto 0 auto;
  padding: 0 20px 60px 20px;
  position: relative;
  z-index: 2;
}

.contact-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 16px 0 rgba(0,0,0,0.04);
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding: 30px 0;
  min-height: 260px;
  border: 1px solid #eee;
}

.contact-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-right: 1px solid #eee;
  padding: 0 16px;
  position: relative;
  &:last-child {
    border-right: none;
  }
}

.item-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
}

.icon-circle {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3ecb6c 0%, #1d9fff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  img {
    width: 48px;
    height: 48px;
  }
}

.item-label {
  font-size: 18px;
  color: #444;
  margin-bottom: 10px;
  text-align: center;
  position: absolute;
  top: 148px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}

.item-value {
  font-size: 20px;
  color: #222;
  font-weight: 400;
  text-align: center;
  margin-top: 200px;
  &.strong {
    font-weight: 700;
    letter-spacing: 1px;
  }
  &.address-text {
    font-size: 16px;
    color: #222;
    font-weight: 400;
    text-align: left;
    margin-top: 200px;
    line-height: 1.7;
    padding: 0 37px;
  }
}

.address-item {
  align-items: center;
  .icon-circle {
    margin-left: 0;
  }
  .item-label {
    margin-left: 0;
  }
  .item-value.address-text {
    margin-left: 0;
    text-align: left;
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .contact-content-wrapper {
    max-width: 1140px;
  }
  
  .contact-card {
    padding: 30px 20px;
  }

  .icon-circle {
    width: 80px;
    height: 80px;
    top: 30px;
    img {
      width: 42px;
      height: 42px;
    }
  }

  .item-label {
    top: 128px;
    font-size: 16px;
  }

  .item-value {
    margin-top: 180px;
    font-size: 18px;
    &.address-text {
      font-size: 15px;
      margin-top: 180px;
    }
  }
}

@media (max-width: 992px) {
  .contact-banner {
    height: 50vh;
    
    .banner-content {
      h1 {
        font-size: 36px;
        padding: 15px 36px;
      }
    }
  }

  .contact-content-wrapper {
    margin-top: 40px;
    padding: 0 15px 40px 15px;
  }

  .contact-card {
    flex-direction: column;
    padding: 25px 15px;
    min-height: auto;
  }

  .contact-item {
    border-right: none;
    border-bottom: 1px solid #eee;
    padding: 20px 0;
    min-height: 200px;
    &:last-child {
      border-bottom: none;
    }
  }

  .icon-circle {
    width: 70px;
    height: 70px;
    top: 25px;
    img {
      width: 36px;
      height: 36px;
    }
  }

  .item-label {
    top: 113px;
    font-size: 16px;
  }

  .item-value {
    margin-top: 120px;
    font-size: 17px;
    &.address-text {
      font-size: 15px;
      margin-top: 120px;
    }
  }
}

@media (max-width: 768px) {
  .contact-banner {
    height: 40vh;
    
    .banner-content {
      h1 {
        font-size: 32px;
        padding: 12px 30px;
        margin-bottom: 10px;
      }
    }
  }

  .contact-content-wrapper {
    margin-top: 30px;
    padding: 0 12px 30px 12px;
  }

  .contact-card {
    padding: 20px 12px;
  }

  .contact-item {
    padding: 15px 0;
    min-height: 180px;
  }

  .icon-circle {
    width: 60px;
    height: 60px;
    top: 20px;
    img {
      width: 32px;
      height: 32px;
    }
  }

  .item-label {
    top: 98px;
    font-size: 15px;
  }

  .item-value {
    margin-top: 100px;
    font-size: 16px;
    &.strong {
      font-size: 17px;
    }
    &.address-text {
      font-size: 14px;
      margin-top: 100px;
      line-height: 1.6;
    }
  }
}

@media (max-width: 480px) {
  .contact-banner {
    height: 35vh;
    
    .banner-content {
      h1 {
        font-size: 28px;
        padding: 10px 24px;
        margin-bottom: 8px;
      }
    }
  }

  .contact-content-wrapper {
    margin-top: 20px;
    padding: 0 10px 20px 10px;
  }

  .contact-card {
    padding: 15px 10px;
  }

  .contact-item {
    padding: 12px 0;
    min-height: 160px;
  }

  .icon-circle {
    width: 50px;
    height: 50px;
    top: 15px;
    img {
      width: 28px;
      height: 28px;
    }
  }

  .item-label {
    top: 83px;
    font-size: 14px;
  }

  .item-value {
    margin-top: 120px;
    font-size: 15px;
    &.strong {
      font-size: 16px;
    }
    &.address-text {
      font-size: 13px;
      margin-top: 120px;
      line-height: 1.5;
    }
  }
}
</style> 